import React from 'react';
import '../WhatIsPlan/styles.css';
import { ReactComponent as TransferIcon } from '../../../assets/Svg/Vector.svg';
import { ReactComponent as MoneyIcon } from '../../../assets/Svg/IconoPeso.svg';
import { ReactComponent as LockIcon } from '../../../assets/Svg/IconoCandado.svg';
import { ReactComponent as CalendarIcon } from '../../../assets/Svg/IconoCalendario.svg';
import { ReactComponent as SupportIcon } from '../../../assets/Svg/IconoCorazon.svg';
import Typography from '@mui/material/Typography';
import ItacaWideBlack from '../../../assets/fonts/itaca/Itaca Wide Black.ttf';
import ItacaWideBold  from '../../../assets/fonts/itaca/Itaca-Wide-Bold.otf';
import AlbertSansRegular from '../../../assets/fonts/Albert_Sans/AlbertSans-Regular.ttf';
import AlbertSansBold from '../../../assets/fonts/Albert_Sans/AlbertSans-Bold.ttf';

// Inyecta todas las fuentes directamente
const fontStyles = `
@font-face {
  font-family: 'Itaca-Wide-Black';
  src: url(${ItacaWideBlack}) format('truetype');
  font-weight: 900;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Itaca-Wide-Bold';
  src: url(${ItacaWideBold}) format('opentype');
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Albert-Sans-Regular';
  src: url(${AlbertSansRegular}) format('opentype');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Albert-Sans-Bold';
  src: url(${AlbertSansBold}) format('opentype');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
/* Agrega más @font-face para otras variantes si es necesario */
`;

// Crea y añade el elemento style al head
const styleElement = document.createElement('style');
styleElement.innerHTML = fontStyles;
document.head.appendChild(styleElement);

const WhatIsPlan = () => {
  // Función reutilizable para Typography con soporte responsive
  const renderText = (text, options = {}) => (
    <Typography
      component={options.component || 'p'} // etiqueta HTML que deseas: 'p', 'h1', 'div', etc.
      color={options.color || '#FFFFFF'}
      fontSize={options.fontSize || '18px'}
      fontFamily={options.fontFamily || '"Albert-Sans-Regular", sans-serif !important'}
      display={options.display || 'inline'}
      //fontWeight={options.fontWeight || 400}
      lineHeight={options.lineHeight || '100%'}
      sx={{
        '@media (max-width: 480px)': {
          fontSize: options.mobileFontSize
        },
        ...options.sx
      }}
      {...options}
    >
      {text}
    </Typography>
  );

  const features = [
    {
      title: "100% Transferible:",
      content: "Si tú no lo necesitas, puede usarse para cualquier familiar o ser querido.",
      bgColor: "#d95729",
      icon: <TransferIcon style={{ width: 60, height: 60 }} />
    },
    {
      title: "Mucho más económico:",
      content: "Es hasta un 50% más barato que contratar un servicio en el momento de la necesidad.",
      bgColor: "#024c3c", 
      icon: <MoneyIcon style={{ width: 60, height: 60 }} />
    },
    {
      title: "Pagos fijos y accesibles:",
      content: "Sin aumentos ni sorpresas. Lo que acuerdas hoy, así se mantiene.",
      bgColor: "#d14081",
      icon: <LockIcon style={{ width: 60, height: 60 }} />
    },
    {
      title: "Vigencia de 99 años:",
      content: "Prácticamente para toda la vida. Tu plan estará ahí cuando se necesite.",
      bgColor: "#fcc10a",
      icon: <CalendarIcon style={{ width: 60, height: 60 }} />
    },
    {
      title: "Sin preocupaciones:",
      content: "Nosotros nos encargamos de todo, desde los trámites hasta el servicio completo.",
      bgColor: "#271e2f",
      icon: <SupportIcon style={{ width: 60, height: 60 }} />
    }
  ];

  return (
    <section className="what-is-plan">
      <div className="plan-intro">
        <h2>
          {renderText("Beneficios de un plan funerario a futuro con Columba Funerales en Toluca", {
            component: 'h2',
            color: '#D14081',
            fontSize: '42px',
            mobileFontSize: '25px !important', // Tamaño para móvil
            fontFamily: "'Itaca-Wide-Bold', sans-serif !important"
            // fontWeight: 700
          })}
        </h2>
        <p>
          {renderText("Un plan funerario a futuro es un servicio que contratas hoy para utilizar cuando llegue el momento, ya sea para ti o para un ser querido. Te permite dejar todo organizado con anticipación, evitando gastos imprevistos, decisiones difíciles y trámites en medio del dolor.", {
            component: 'p',
            fontFamily: "'Albert-Sans-Regular', sans-serif !important",
            color: '#271E2F',
            fontSize: '18px',
            mobileFontSize: '16px !important' // Tamaño para móvil
          })}
        </p>
      </div>

      <div className="plan-features-container">
        {features.map((feature, index) => (
          <div 
            key={`feature-${index}`}
            className={`feature-card ${index >= 3 ? 'centered-card' : ''}`}
            style={{ backgroundColor: feature.bgColor }}
          >
            <div className="feature-icon">
              {feature.icon}
            </div>
            <h3>
              {renderText(feature.title, {
                component: 'h3',
                fontSize: '20px',
                mobileFontSize: '20px !important', // Tamaño para móvil
                fontFamily: "'Albert-Sans-Bold', sans-serif !important"
              })}
            </h3>
            <p>
              {renderText(feature.content, {
                component: 'p',
                fontSize: '18px',
                mobileFontSize: '18px !important' // Tamaño para móvil
              })}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default React.memo(WhatIsPlan);